import { RootState } from '../../../../rootReducer';

export const invoiceReportSelector = (state: RootState) => state.eventsLogModuleReducer.InvoicesReportReducer;
